<template>
  <v-container class="pa-0">
    <TitleWithSwitch
      :model-value="reinforcementInput.inner_berm_reinforcement_input.is_enabled"
      @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.is_enabled', value: $event})"
      :class="[
                getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.is_enabled'),
                isLocked ? 'disable-events' : '']"
      text="Inner Berm"
    />
    <v-expand-transition>
      <v-row
        v-if="reinforcementInput.inner_berm_reinforcement_input.is_enabled"
        dense
      >
        <v-col sm="12" md="6">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.slope_berm"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.slope_berm', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.slope_berm'),
                  isLocked ? 'disable-events' : '']"
            label="Slope"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="6">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.lower_slope"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.lower_slope', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.lower_slope'),
                  isLocked ? 'disable-events' : '']"
            label="Lower Slope"
            hide-details
            type="number"
          />
        </v-col>

        <v-col sm="12" md="3">
          <span class="text-label">Height</span>
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.height_from"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.height_from', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.height_from'),
                  isLocked ? 'disable-events' : '']"
            label="Start"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.height_to"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.height_to', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.height_to'),
                  isLocked ? 'disable-events' : '']"
            label="End"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.height_step"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.height_step', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.height_step'),
                  isLocked ? 'disable-events' : '']"
            label="Step"
            hide-details
            type="number"
          />
        </v-col>

        <v-col sm="12" md="3">
          <span class="text-label">Width</span>
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.width_from"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.width_from', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.width_from'),
                  isLocked ? 'disable-events' : '']"
            label="Start"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.width_to"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.width_to', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.width_to'),
                  isLocked ? 'disable-events' : '']"
            label="End"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.inner_berm_reinforcement_input.width_step"
            @update:model-value="onValueChanged({parameter: 'inner_berm_reinforcement_input.width_step', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'inner_berm_reinforcement_input.width_step'),
                  isLocked ? 'disable-events' : '']"
            label="Step"
            hide-details
            type="number"
          />
        </v-col>
      </v-row>
    </v-expand-transition>
  </v-container>
</template>

<script>
  import TitleWithSwitch from "@/components/reinforcement/TitleWithSwitch.vue"
  import DirtyFieldsMixIn from "@/mixins/DirtyFieldsMixIn.vue"
  import ReinforcementFormMixin from "@/mixins/ReinforcementFormMixin.vue"

  export default {
    name: "InnerBermReinforcementForm",
    components: { TitleWithSwitch },
    mixins: [DirtyFieldsMixIn, ReinforcementFormMixin]
  }
</script>

<style scoped>
  .v-input {
    font-size: 14px;
  }

  .text-label {
    height: 100%;
    display: flex;
    align-items: flex-end;
    font-size: 14px;
  }
</style>
